import { useEffect } from "react";

/**
 * 手势返回：从屏幕左边缘向右滑动触发返回（PWA 独立窗口里没有浏览器自带的返回手势）。
 * 浏览器里 iOS Safari / Android 本身的返回手势作用于同一份 history，行为一致。
 */
export function useEdgeSwipeBack(onBack: () => void, opts: { enabled: boolean; edge?: number; distance?: number } = { enabled: true }) {
  const { enabled, edge = 24, distance = 72 } = opts;
  useEffect(() => {
    if (!enabled) return;
    let start: { x: number; y: number } | null = null;
    const onStart = (e: TouchEvent) => {
      const t = e.touches[0];
      start = t && t.clientX <= edge ? { x: t.clientX, y: t.clientY } : null;
    };
    const onEnd = (e: TouchEvent) => {
      const t = e.changedTouches[0];
      if (!start || !t) return;
      const dx = t.clientX - start.x;
      const dy = Math.abs(t.clientY - start.y);
      start = null;
      if (dx >= distance && dy < dx / 2) onBack();
    };
    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchend", onEnd, { passive: true });
    return () => {
      window.removeEventListener("touchstart", onStart);
      window.removeEventListener("touchend", onEnd);
    };
  }, [enabled, edge, distance, onBack]);
}
